/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as import0 from '@angular/core/src/linker/ng_module_factory';
import * as import1 from '@angular/material/button/button';
import * as import2 from '@angular/common/src/common_module';
import * as import3 from '@angular/material/core/compatibility/compatibility';
import * as import4 from '@angular/material/core/ripple/ripple';
import * as import5 from '@angular/common/src/localization';
import * as import7 from '@angular/core/src/i18n/tokens';
import * as import8 from '@angular/material/core/overlay/scroll/scroll-dispatcher';
import * as import9 from '@angular/material/core/overlay/position/viewport-ruler';
import * as import10 from '@angular/core/src/change_detection/change_detection_util';
import * as import11 from '@angular/core/src/linker/view';
import * as import12 from '@angular/core/src/linker/view_utils';
import * as import14 from '@angular/core/src/metadata/view';
import * as import15 from '@angular/core/src/linker/view_type';
import * as import16 from '@angular/core/src/change_detection/constants';
import * as import17 from '@angular/core/src/linker/component_factory';
import * as import18 from '@angular/core/src/linker/element_ref';
import * as import19 from './button.css.ngstyle';
import * as import20 from '../core/ripple/ripple.ngfactory';
import * as import21 from '@angular/core/src/linker/view_container';
import * as import22 from '@angular/core/src/zone/ng_zone';
import * as import23 from '../../common/src/directives/ng_if.ngfactory';
import * as import24 from '@angular/core/src/linker/template_ref';
import * as import25 from '@angular/common/src/directives/ng_if';
var MdButtonModuleInjector = (function (_super) {
    __extends(MdButtonModuleInjector, _super);
    function MdButtonModuleInjector(parent) {
        return _super.call(this, parent, [], []) || this;
    }
    Object.defineProperty(MdButtonModuleInjector.prototype, "_NgLocalization_4", {
        get: function () {
            if ((this.__NgLocalization_4 == null)) {
                (this.__NgLocalization_4 = new import5.NgLocaleLocalization(this.parent.get(import7.LOCALE_ID)));
            }
            return this.__NgLocalization_4;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdButtonModuleInjector.prototype, "_ScrollDispatcher_5", {
        get: function () {
            if ((this.__ScrollDispatcher_5 == null)) {
                (this.__ScrollDispatcher_5 = import8.SCROLL_DISPATCHER_PROVIDER_FACTORY(this.parent.get(import8.ScrollDispatcher, null)));
            }
            return this.__ScrollDispatcher_5;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdButtonModuleInjector.prototype, "_ViewportRuler_6", {
        get: function () {
            if ((this.__ViewportRuler_6 == null)) {
                (this.__ViewportRuler_6 = import9.VIEWPORT_RULER_PROVIDER_FACTORY(this.parent.get(import9.ViewportRuler, null), this._ScrollDispatcher_5));
            }
            return this.__ViewportRuler_6;
        },
        enumerable: true,
        configurable: true
    });
    MdButtonModuleInjector.prototype.createInternal = function () {
        this._CommonModule_0 = new import2.CommonModule();
        this._CompatibilityModule_1 = new import3.CompatibilityModule();
        this._MdRippleModule_2 = new import4.MdRippleModule();
        this._MdButtonModule_3 = new import1.MdButtonModule();
        return this._MdButtonModule_3;
    };
    MdButtonModuleInjector.prototype.getInternal = function (token, notFoundResult) {
        if ((token === import2.CommonModule)) {
            return this._CommonModule_0;
        }
        if ((token === import3.CompatibilityModule)) {
            return this._CompatibilityModule_1;
        }
        if ((token === import4.MdRippleModule)) {
            return this._MdRippleModule_2;
        }
        if ((token === import1.MdButtonModule)) {
            return this._MdButtonModule_3;
        }
        if ((token === import5.NgLocalization)) {
            return this._NgLocalization_4;
        }
        if ((token === import8.ScrollDispatcher)) {
            return this._ScrollDispatcher_5;
        }
        if ((token === import9.ViewportRuler)) {
            return this._ViewportRuler_6;
        }
        return notFoundResult;
    };
    MdButtonModuleInjector.prototype.destroyInternal = function () {
    };
    return MdButtonModuleInjector;
}(import0.NgModuleInjector));
export var MdButtonModuleNgFactory = new import0.NgModuleFactory(MdButtonModuleInjector, import1.MdButtonModule);
var Wrapper_MdButton = (function () {
    function Wrapper_MdButton(p0, p1) {
        this._changed = false;
        this.context = new import1.MdButton(p0, p1);
        this._expr_0 = import10.UNINITIALIZED;
        this._expr_1 = import10.UNINITIALIZED;
        this._expr_2 = import10.UNINITIALIZED;
        this._expr_3 = import10.UNINITIALIZED;
        this._expr_4 = import10.UNINITIALIZED;
    }
    Wrapper_MdButton.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_MdButton.prototype.ngOnDestroy = function () {
    };
    Wrapper_MdButton.prototype.check_disableRipple = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import12.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this._changed = true;
            this.context.disableRipple = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_MdButton.prototype.check_disabled = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import12.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this._changed = true;
            this.context.disabled = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_MdButton.prototype.check_color = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import12.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this._changed = true;
            this.context.color = currValue;
            this._expr_2 = currValue;
        }
    };
    Wrapper_MdButton.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_MdButton.prototype.checkHost = function (view, componentView, el, throwOnChange) {
        var currVal_3 = this.context.disabled;
        if (import12.checkBinding(throwOnChange, this._expr_3, currVal_3)) {
            view.renderer.setElementProperty(el, 'disabled', currVal_3);
            this._expr_3 = currVal_3;
        }
        var currVal_4 = this.context._isKeyboardFocused;
        if (import12.checkBinding(throwOnChange, this._expr_4, currVal_4)) {
            view.renderer.setElementClass(el, 'mat-button-focus', currVal_4);
            this._expr_4 = currVal_4;
        }
    };
    Wrapper_MdButton.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        if ((eventName == 'mousedown')) {
            var pd_sub_0 = (this.context._setMousedown() !== false);
            result = (pd_sub_0 && result);
        }
        if ((eventName == 'focus')) {
            var pd_sub_1 = (this.context._setKeyboardFocus() !== false);
            result = (pd_sub_1 && result);
        }
        if ((eventName == 'blur')) {
            var pd_sub_2 = (this.context._removeKeyboardFocus() !== false);
            result = (pd_sub_2 && result);
        }
        return result;
    };
    Wrapper_MdButton.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_MdButton;
}());
export { Wrapper_MdButton };
var Wrapper_MdAnchor = (function () {
    function Wrapper_MdAnchor(p0, p1) {
        this._changed = false;
        this.context = new import1.MdAnchor(p0, p1);
        this._expr_0 = import10.UNINITIALIZED;
        this._expr_1 = import10.UNINITIALIZED;
        this._expr_2 = import10.UNINITIALIZED;
        this._expr_3 = import10.UNINITIALIZED;
        this._expr_4 = import10.UNINITIALIZED;
        this._expr_5 = import10.UNINITIALIZED;
        this._expr_6 = import10.UNINITIALIZED;
    }
    Wrapper_MdAnchor.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_MdAnchor.prototype.ngOnDestroy = function () {
    };
    Wrapper_MdAnchor.prototype.check_disableRipple = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import12.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this._changed = true;
            this.context.disableRipple = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_MdAnchor.prototype.check_disabled = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import12.checkBinding(throwOnChange, this._expr_1, currValue))) {
            this._changed = true;
            this.context.disabled = currValue;
            this._expr_1 = currValue;
        }
    };
    Wrapper_MdAnchor.prototype.check_color = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import12.checkBinding(throwOnChange, this._expr_2, currValue))) {
            this._changed = true;
            this.context.color = currValue;
            this._expr_2 = currValue;
        }
    };
    Wrapper_MdAnchor.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_MdAnchor.prototype.checkHost = function (view, componentView, el, throwOnChange) {
        var currVal_3 = this.context.disabled;
        if (import12.checkBinding(throwOnChange, this._expr_3, currVal_3)) {
            view.renderer.setElementAttribute(el, 'disabled', ((currVal_3 == null) ? null : currVal_3.toString()));
            this._expr_3 = currVal_3;
        }
        var currVal_4 = this.context._isAriaDisabled;
        if (import12.checkBinding(throwOnChange, this._expr_4, currVal_4)) {
            view.renderer.setElementAttribute(el, 'aria-disabled', ((currVal_4 == null) ? null : currVal_4.toString()));
            this._expr_4 = currVal_4;
        }
        var currVal_5 = this.context._isKeyboardFocused;
        if (import12.checkBinding(throwOnChange, this._expr_5, currVal_5)) {
            view.renderer.setElementClass(el, 'mat-button-focus', currVal_5);
            this._expr_5 = currVal_5;
        }
        var currVal_6 = this.context.tabIndex;
        if (import12.checkBinding(throwOnChange, this._expr_6, currVal_6)) {
            view.renderer.setElementProperty(el, 'tabIndex', currVal_6);
            this._expr_6 = currVal_6;
        }
    };
    Wrapper_MdAnchor.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        if ((eventName == 'mousedown')) {
            var pd_sub_0 = (this.context._setMousedown() !== false);
            result = (pd_sub_0 && result);
        }
        if ((eventName == 'focus')) {
            var pd_sub_1 = (this.context._setKeyboardFocus() !== false);
            result = (pd_sub_1 && result);
        }
        if ((eventName == 'blur')) {
            var pd_sub_2 = (this.context._removeKeyboardFocus() !== false);
            result = (pd_sub_2 && result);
        }
        if ((eventName == 'click')) {
            var pd_sub_3 = (this.context._haltDisabledEvents($event) !== false);
            result = (pd_sub_3 && result);
        }
        return result;
    };
    Wrapper_MdAnchor.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_MdAnchor;
}());
export { Wrapper_MdAnchor };
var Wrapper_MdButtonCssMatStyler = (function () {
    function Wrapper_MdButtonCssMatStyler() {
        this._changed = false;
        this.context = new import1.MdButtonCssMatStyler();
        this._expr_0 = import10.UNINITIALIZED;
    }
    Wrapper_MdButtonCssMatStyler.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_MdButtonCssMatStyler.prototype.ngOnDestroy = function () {
    };
    Wrapper_MdButtonCssMatStyler.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_MdButtonCssMatStyler.prototype.checkHost = function (view, componentView, el, throwOnChange) {
        var currVal_0 = true;
        if (import12.checkBinding(throwOnChange, this._expr_0, currVal_0)) {
            view.renderer.setElementClass(el, 'mat-button', currVal_0);
            this._expr_0 = currVal_0;
        }
    };
    Wrapper_MdButtonCssMatStyler.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_MdButtonCssMatStyler.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_MdButtonCssMatStyler;
}());
export { Wrapper_MdButtonCssMatStyler };
var Wrapper_MdRaisedButtonCssMatStyler = (function () {
    function Wrapper_MdRaisedButtonCssMatStyler() {
        this._changed = false;
        this.context = new import1.MdRaisedButtonCssMatStyler();
        this._expr_0 = import10.UNINITIALIZED;
    }
    Wrapper_MdRaisedButtonCssMatStyler.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_MdRaisedButtonCssMatStyler.prototype.ngOnDestroy = function () {
    };
    Wrapper_MdRaisedButtonCssMatStyler.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_MdRaisedButtonCssMatStyler.prototype.checkHost = function (view, componentView, el, throwOnChange) {
        var currVal_0 = true;
        if (import12.checkBinding(throwOnChange, this._expr_0, currVal_0)) {
            view.renderer.setElementClass(el, 'mat-raised-button', currVal_0);
            this._expr_0 = currVal_0;
        }
    };
    Wrapper_MdRaisedButtonCssMatStyler.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_MdRaisedButtonCssMatStyler.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_MdRaisedButtonCssMatStyler;
}());
export { Wrapper_MdRaisedButtonCssMatStyler };
var Wrapper_MdIconButtonCssMatStyler = (function () {
    function Wrapper_MdIconButtonCssMatStyler() {
        this._changed = false;
        this.context = new import1.MdIconButtonCssMatStyler();
        this._expr_0 = import10.UNINITIALIZED;
    }
    Wrapper_MdIconButtonCssMatStyler.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_MdIconButtonCssMatStyler.prototype.ngOnDestroy = function () {
    };
    Wrapper_MdIconButtonCssMatStyler.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_MdIconButtonCssMatStyler.prototype.checkHost = function (view, componentView, el, throwOnChange) {
        var currVal_0 = true;
        if (import12.checkBinding(throwOnChange, this._expr_0, currVal_0)) {
            view.renderer.setElementClass(el, 'mat-icon-button', currVal_0);
            this._expr_0 = currVal_0;
        }
    };
    Wrapper_MdIconButtonCssMatStyler.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_MdIconButtonCssMatStyler.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_MdIconButtonCssMatStyler;
}());
export { Wrapper_MdIconButtonCssMatStyler };
var Wrapper_MdFabCssMatStyler = (function () {
    function Wrapper_MdFabCssMatStyler() {
        this._changed = false;
        this.context = new import1.MdFabCssMatStyler();
        this._expr_0 = import10.UNINITIALIZED;
    }
    Wrapper_MdFabCssMatStyler.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_MdFabCssMatStyler.prototype.ngOnDestroy = function () {
    };
    Wrapper_MdFabCssMatStyler.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_MdFabCssMatStyler.prototype.checkHost = function (view, componentView, el, throwOnChange) {
        var currVal_0 = true;
        if (import12.checkBinding(throwOnChange, this._expr_0, currVal_0)) {
            view.renderer.setElementClass(el, 'mat-fab', currVal_0);
            this._expr_0 = currVal_0;
        }
    };
    Wrapper_MdFabCssMatStyler.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_MdFabCssMatStyler.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_MdFabCssMatStyler;
}());
export { Wrapper_MdFabCssMatStyler };
var Wrapper_MdMiniFabCssMatStyler = (function () {
    function Wrapper_MdMiniFabCssMatStyler() {
        this._changed = false;
        this.context = new import1.MdMiniFabCssMatStyler();
        this._expr_0 = import10.UNINITIALIZED;
    }
    Wrapper_MdMiniFabCssMatStyler.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_MdMiniFabCssMatStyler.prototype.ngOnDestroy = function () {
    };
    Wrapper_MdMiniFabCssMatStyler.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_MdMiniFabCssMatStyler.prototype.checkHost = function (view, componentView, el, throwOnChange) {
        var currVal_0 = true;
        if (import12.checkBinding(throwOnChange, this._expr_0, currVal_0)) {
            view.renderer.setElementClass(el, 'mat-mini-fab', currVal_0);
            this._expr_0 = currVal_0;
        }
    };
    Wrapper_MdMiniFabCssMatStyler.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_MdMiniFabCssMatStyler.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_MdMiniFabCssMatStyler;
}());
export { Wrapper_MdMiniFabCssMatStyler };
var renderType_MdButton_Host = import12.createRenderComponentType('', 0, import14.ViewEncapsulation.None, [], {});
var View_MdButton_Host0 = (function (_super) {
    __extends(View_MdButton_Host0, _super);
    function View_MdButton_Host0(viewUtils, parentView, parentIndex, parentElement) {
        return _super.call(this, View_MdButton_Host0, renderType_MdButton_Host, import15.ViewType.HOST, viewUtils, parentView, parentIndex, parentElement, import16.ChangeDetectorStatus.CheckAlways) || this;
    }
    View_MdButton_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import12.selectOrCreateRenderHostElement(this.renderer, 'button', new import12.InlineArray2(2, 'md-button', ''), rootSelector, null);
        this.compView_0 = new View_MdButton0(this.viewUtils, this, 0, this._el_0);
        this._MdButton_0_3 = new Wrapper_MdButton(new import18.ElementRef(this._el_0), this.renderer);
        this.compView_0.create(this._MdButton_0_3.context);
        var disposable_0 = import12.subscribeToRenderElement(this, this._el_0, new import12.InlineArray8(6, 'mousedown', null, 'focus', null, 'blur', null), this.eventHandler(this.handleEvent_0));
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), [disposable_0]);
        return new import17.ComponentRef_(0, this, this._el_0, this._MdButton_0_3.context);
    };
    View_MdButton_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import1.MdButton) && (0 === requestNodeIndex))) {
            return this._MdButton_0_3.context;
        }
        return notFoundResult;
    };
    View_MdButton_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        if (this._MdButton_0_3.ngDoCheck(this, this._el_0, throwOnChange)) {
            this.compView_0.markAsCheckOnce();
        }
        this._MdButton_0_3.checkHost(this, this.compView_0, this._el_0, throwOnChange);
        this.compView_0.internalDetectChanges(throwOnChange);
    };
    View_MdButton_Host0.prototype.destroyInternal = function () {
        this.compView_0.destroy();
    };
    View_MdButton_Host0.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    View_MdButton_Host0.prototype.visitProjectableNodesInternal = function (nodeIndex, ngContentIndex, cb, ctx) {
        if (((nodeIndex == 0) && (ngContentIndex == 0))) { }
    };
    View_MdButton_Host0.prototype.handleEvent_0 = function (eventName, $event) {
        this.compView_0.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._MdButton_0_3.handleEvent(eventName, $event) && result);
        return result;
    };
    return View_MdButton_Host0;
}(import11.AppView));
export var MdButtonNgFactory = new import17.ComponentFactory('button[md-button], button[md-raised-button], button[md-icon-button],button[md-fab], button[md-mini-fab],button[mat-button], button[mat-raised-button], button[mat-icon-button],button[mat-fab], button[mat-mini-fab]', View_MdButton_Host0, import1.MdButton);
var styles_MdButton = [import19.styles];
var View_MdButton1 = (function (_super) {
    __extends(View_MdButton1, _super);
    function View_MdButton1(viewUtils, parentView, parentIndex, parentElement, declaredViewContainer) {
        var _this = _super.call(this, View_MdButton1, renderType_MdButton, import15.ViewType.EMBEDDED, viewUtils, parentView, parentIndex, parentElement, import16.ChangeDetectorStatus.CheckAlways, declaredViewContainer) || this;
        _this._expr_2 = import10.UNINITIALIZED;
        return _this;
    }
    View_MdButton1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import12.createRenderElement(this.renderer, null, 'div', new import12.InlineArray4(4, 'class', 'mat-button-ripple', 'md-ripple', ''), null);
        this._MdRipple_0_3 = new import20.Wrapper_MdRipple(new import18.ElementRef(this._el_0), this.parentView.injectorGet(import22.NgZone, this.parentIndex), this.parentView.injectorGet(import9.ViewportRuler, this.parentIndex));
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), null);
        return null;
    };
    View_MdButton1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import4.MdRipple) && (0 === requestNodeIndex))) {
            return this._MdRipple_0_3.context;
        }
        return notFoundResult;
    };
    View_MdButton1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.parentView.context._getHostElement();
        this._MdRipple_0_3.check_trigger(currVal_0_0_0, throwOnChange, false);
        this._MdRipple_0_3.ngDoCheck(this, this._el_0, throwOnChange);
        var currVal_2 = this.parentView.context._isRoundButton();
        if (import12.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setElementClass(this._el_0, 'mat-button-ripple-round', currVal_2);
            this._expr_2 = currVal_2;
        }
        this._MdRipple_0_3.checkHost(this, this, this._el_0, throwOnChange);
    };
    View_MdButton1.prototype.destroyInternal = function () {
        this._MdRipple_0_3.ngOnDestroy();
    };
    View_MdButton1.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    return View_MdButton1;
}(import11.AppView));
var renderType_MdButton = import12.createRenderComponentType('', 1, import14.ViewEncapsulation.None, styles_MdButton, {});
var View_MdButton0 = (function (_super) {
    __extends(View_MdButton0, _super);
    function View_MdButton0(viewUtils, parentView, parentIndex, parentElement) {
        return _super.call(this, View_MdButton0, renderType_MdButton, import15.ViewType.COMPONENT, viewUtils, parentView, parentIndex, parentElement, import16.ChangeDetectorStatus.CheckOnce) || this;
    }
    View_MdButton0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.parentElement);
        this._el_0 = import12.createRenderElement(this.renderer, parentRenderNode, 'span', new import12.InlineArray2(2, 'class', 'mat-button-wrapper'), null);
        this.projectNodes(this._el_0, 0);
        this._anchor_1 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._vc_1 = new import21.ViewContainer(1, null, this, this._anchor_1);
        this._TemplateRef_1_5 = new import24.TemplateRef_(this, 1, this._anchor_1);
        this._NgIf_1_6 = new import23.Wrapper_NgIf(this._vc_1.vcRef, this._TemplateRef_1_5);
        this._el_2 = import12.createRenderElement(this.renderer, parentRenderNode, 'div', new import12.InlineArray2(2, 'class', 'mat-button-focus-overlay'), null);
        var disposable_0 = import12.subscribeToRenderElement(this, this._el_2, new import12.InlineArray2(2, 'touchstart', null), this.eventHandler(this.handleEvent_2));
        this.init(null, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._anchor_1,
            this._el_2
        ]), [disposable_0]);
        return null;
    };
    View_MdButton0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import24.TemplateRef) && (1 === requestNodeIndex))) {
            return this._TemplateRef_1_5;
        }
        if (((token === import25.NgIf) && (1 === requestNodeIndex))) {
            return this._NgIf_1_6.context;
        }
        return notFoundResult;
    };
    View_MdButton0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_1_0_0 = !this.context._isRippleDisabled();
        this._NgIf_1_6.check_ngIf(currVal_1_0_0, throwOnChange, false);
        this._NgIf_1_6.ngDoCheck(this, this._anchor_1, throwOnChange);
        this._vc_1.detectChangesInNestedViews(throwOnChange);
    };
    View_MdButton0.prototype.destroyInternal = function () {
        this._vc_1.destroyNestedViews();
    };
    View_MdButton0.prototype.createEmbeddedViewInternal = function (nodeIndex) {
        if ((nodeIndex == 1)) {
            return new View_MdButton1(this.viewUtils, this, 1, this._anchor_1, this._vc_1);
        }
        return null;
    };
    View_MdButton0.prototype.handleEvent_2 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'touchstart')) {
            var pd_sub_0 = ($event.preventDefault() !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    return View_MdButton0;
}(import11.AppView));
export { View_MdButton0 };
var renderType_MdAnchor_Host = import12.createRenderComponentType('', 0, import14.ViewEncapsulation.None, [], {});
var View_MdAnchor_Host0 = (function (_super) {
    __extends(View_MdAnchor_Host0, _super);
    function View_MdAnchor_Host0(viewUtils, parentView, parentIndex, parentElement) {
        return _super.call(this, View_MdAnchor_Host0, renderType_MdAnchor_Host, import15.ViewType.HOST, viewUtils, parentView, parentIndex, parentElement, import16.ChangeDetectorStatus.CheckAlways) || this;
    }
    View_MdAnchor_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import12.selectOrCreateRenderHostElement(this.renderer, 'a', new import12.InlineArray2(2, 'md-button', ''), rootSelector, null);
        this.compView_0 = new View_MdAnchor0(this.viewUtils, this, 0, this._el_0);
        this._MdAnchor_0_3 = new Wrapper_MdAnchor(new import18.ElementRef(this._el_0), this.renderer);
        this.compView_0.create(this._MdAnchor_0_3.context);
        var disposable_0 = import12.subscribeToRenderElement(this, this._el_0, new import12.InlineArray8(8, 'mousedown', null, 'focus', null, 'blur', null, 'click', null), this.eventHandler(this.handleEvent_0));
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), [disposable_0]);
        return new import17.ComponentRef_(0, this, this._el_0, this._MdAnchor_0_3.context);
    };
    View_MdAnchor_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import1.MdAnchor) && (0 === requestNodeIndex))) {
            return this._MdAnchor_0_3.context;
        }
        return notFoundResult;
    };
    View_MdAnchor_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._MdAnchor_0_3.ngDoCheck(this, this._el_0, throwOnChange);
        this._MdAnchor_0_3.checkHost(this, this.compView_0, this._el_0, throwOnChange);
        this.compView_0.internalDetectChanges(throwOnChange);
    };
    View_MdAnchor_Host0.prototype.destroyInternal = function () {
        this.compView_0.destroy();
    };
    View_MdAnchor_Host0.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    View_MdAnchor_Host0.prototype.visitProjectableNodesInternal = function (nodeIndex, ngContentIndex, cb, ctx) {
        if (((nodeIndex == 0) && (ngContentIndex == 0))) { }
    };
    View_MdAnchor_Host0.prototype.handleEvent_0 = function (eventName, $event) {
        this.compView_0.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._MdAnchor_0_3.handleEvent(eventName, $event) && result);
        return result;
    };
    return View_MdAnchor_Host0;
}(import11.AppView));
export var MdAnchorNgFactory = new import17.ComponentFactory('a[md-button], a[md-raised-button], a[md-icon-button], a[md-fab], a[md-mini-fab],\n             a[mat-button], a[mat-raised-button], a[mat-icon-button], a[mat-fab], a[mat-mini-fab]', View_MdAnchor_Host0, import1.MdAnchor);
var styles_MdAnchor = [import19.styles];
var View_MdAnchor1 = (function (_super) {
    __extends(View_MdAnchor1, _super);
    function View_MdAnchor1(viewUtils, parentView, parentIndex, parentElement, declaredViewContainer) {
        var _this = _super.call(this, View_MdAnchor1, renderType_MdAnchor, import15.ViewType.EMBEDDED, viewUtils, parentView, parentIndex, parentElement, import16.ChangeDetectorStatus.CheckAlways, declaredViewContainer) || this;
        _this._expr_2 = import10.UNINITIALIZED;
        return _this;
    }
    View_MdAnchor1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import12.createRenderElement(this.renderer, null, 'div', new import12.InlineArray4(4, 'class', 'mat-button-ripple', 'md-ripple', ''), null);
        this._MdRipple_0_3 = new import20.Wrapper_MdRipple(new import18.ElementRef(this._el_0), this.parentView.injectorGet(import22.NgZone, this.parentIndex), this.parentView.injectorGet(import9.ViewportRuler, this.parentIndex));
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), null);
        return null;
    };
    View_MdAnchor1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import4.MdRipple) && (0 === requestNodeIndex))) {
            return this._MdRipple_0_3.context;
        }
        return notFoundResult;
    };
    View_MdAnchor1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.parentView.context._getHostElement();
        this._MdRipple_0_3.check_trigger(currVal_0_0_0, throwOnChange, false);
        this._MdRipple_0_3.ngDoCheck(this, this._el_0, throwOnChange);
        var currVal_2 = this.parentView.context._isRoundButton();
        if (import12.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setElementClass(this._el_0, 'mat-button-ripple-round', currVal_2);
            this._expr_2 = currVal_2;
        }
        this._MdRipple_0_3.checkHost(this, this, this._el_0, throwOnChange);
    };
    View_MdAnchor1.prototype.destroyInternal = function () {
        this._MdRipple_0_3.ngOnDestroy();
    };
    View_MdAnchor1.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    return View_MdAnchor1;
}(import11.AppView));
var renderType_MdAnchor = import12.createRenderComponentType('', 1, import14.ViewEncapsulation.None, styles_MdAnchor, {});
var View_MdAnchor0 = (function (_super) {
    __extends(View_MdAnchor0, _super);
    function View_MdAnchor0(viewUtils, parentView, parentIndex, parentElement) {
        return _super.call(this, View_MdAnchor0, renderType_MdAnchor, import15.ViewType.COMPONENT, viewUtils, parentView, parentIndex, parentElement, import16.ChangeDetectorStatus.CheckAlways) || this;
    }
    View_MdAnchor0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.parentElement);
        this._el_0 = import12.createRenderElement(this.renderer, parentRenderNode, 'span', new import12.InlineArray2(2, 'class', 'mat-button-wrapper'), null);
        this.projectNodes(this._el_0, 0);
        this._anchor_1 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._vc_1 = new import21.ViewContainer(1, null, this, this._anchor_1);
        this._TemplateRef_1_5 = new import24.TemplateRef_(this, 1, this._anchor_1);
        this._NgIf_1_6 = new import23.Wrapper_NgIf(this._vc_1.vcRef, this._TemplateRef_1_5);
        this._el_2 = import12.createRenderElement(this.renderer, parentRenderNode, 'div', new import12.InlineArray2(2, 'class', 'mat-button-focus-overlay'), null);
        var disposable_0 = import12.subscribeToRenderElement(this, this._el_2, new import12.InlineArray2(2, 'touchstart', null), this.eventHandler(this.handleEvent_2));
        this.init(null, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._anchor_1,
            this._el_2
        ]), [disposable_0]);
        return null;
    };
    View_MdAnchor0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import24.TemplateRef) && (1 === requestNodeIndex))) {
            return this._TemplateRef_1_5;
        }
        if (((token === import25.NgIf) && (1 === requestNodeIndex))) {
            return this._NgIf_1_6.context;
        }
        return notFoundResult;
    };
    View_MdAnchor0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_1_0_0 = !this.context._isRippleDisabled();
        this._NgIf_1_6.check_ngIf(currVal_1_0_0, throwOnChange, false);
        this._NgIf_1_6.ngDoCheck(this, this._anchor_1, throwOnChange);
        this._vc_1.detectChangesInNestedViews(throwOnChange);
    };
    View_MdAnchor0.prototype.destroyInternal = function () {
        this._vc_1.destroyNestedViews();
    };
    View_MdAnchor0.prototype.createEmbeddedViewInternal = function (nodeIndex) {
        if ((nodeIndex == 1)) {
            return new View_MdAnchor1(this.viewUtils, this, 1, this._anchor_1, this._vc_1);
        }
        return null;
    };
    View_MdAnchor0.prototype.handleEvent_2 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'touchstart')) {
            var pd_sub_0 = ($event.preventDefault() !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    return View_MdAnchor0;
}(import11.AppView));
export { View_MdAnchor0 };
//# sourceMappingURL=button.ngfactory.js.map